const Macro = ({macro,value})=>(
	<span className="d-inline-flex flex-column align-items-center ml-2">
		<small className="text-muted">{macro}</small>
		<small>{Boolean(value)?value:'N/A'}</small>
	</span>
)

const Food = ({food})=>{
	const qty = food.quantity
	const portion = food.portions.find(
		portion => portion.id===food.food_db_portion_id
	) || food.portions[0]
	return (
		<div 
			className="d-flex flex-wrap pt-1 mt-1"
			style={{borderTop:'1px solid #ccc'}}
		>
			<small className="mr-2">
				<strong>{food.food_name}</strong>
			</small>
			<div className="ml-auto">
				<Macro
					macro="cal"
					value={(qty*portion.calories).toFixed(0)}
				/>
				<Macro
					macro="pro"
					value={(qty*portion.protein).toFixed(0)}
				/>
				<Macro
					macro="carbs"
					value={(qty*portion.carbs).toFixed(0)}
				/>
				<Macro
					macro="fat"
					value={(qty*portion.fat).toFixed(0)}
				/>
				<Macro
					macro="sodium"
					value={(qty*portion.sodium).toFixed(0)}
				/>
				<Macro
					macro="fiber"
					value={(qty*portion.fiber).toFixed(0)}
				/>
			</div>
		</div>
	)
}

const Meal = ({meal})=>{
	console.log(meal)
	return (
		<div style={{borderTop:'1px solid #ccc'}}>
			<div>
				<small>
					<strong>Meal: {meal.name}</strong>
				</small>
			</div>
			{Boolean(meal.description)&&
				<div>
					<small style={{whiteSpace:'pre-line'}}>
						<strong>Description:</strong> {meal.description}
					</small>
				</div>
			}
			{Boolean(meal.ingredients)&&
				<div>
					<small>
						<strong>Ingredients:</strong>
					</small>
					<small className="d-block" style={{whiteSpace:'pre-line'}}>
						{meal.ingredients}
					</small>
				</div>
			}
			{Boolean(meal.description)&&
				<div>
					<small style={{whiteSpace:'pre-line'}}>
						<strong>Description:</strong> {meal.description}
					</small>
				</div>
			}
			{meal.foods.length>0&&
				<small className="d-block"><strong>Foods:</strong></small>
			}
			{meal.foods.map(food=>(
				<div className="pl-3">
					<Food food={food}/>
				</div>
			))}
		</div>
	)
}

export default function NutritionPreview({nutrition}){
	return (
		<div style={{borderBottom:'1px solid #ccc'}} className="pb-2">
			<div>
				<strong>{nutrition.notes}</strong>
			</div>
			{nutrition.food.map(item=>{
				switch(item.type){
					case "meal": return <Meal meal={item}/>
					case "food": return <Food food={item}/>
				}
			})}
		</div>
	)
}